import {
  GEOFENCE_RADIUS_METERS,
  LAST_KNOWN_LOCATION_MAX_AGE_MS,
} from "common/Constants";

const LAST_KNOWN_LOCATION_KEY = "lastKnownLocation";

export const saveLastKnownLocation = (latitude, longitude) => {
  try {
    window.localStorage.setItem(
      LAST_KNOWN_LOCATION_KEY,
      JSON.stringify({ latitude, longitude, timestamp: Date.now() })
    );
  } catch (e) {
    // Storage full / disabled — the live fix still works, just no fallback.
  }
};

// Returns the cached position if it's recent enough, otherwise null.
export const getLastKnownLocation = (
  maxAgeMs = LAST_KNOWN_LOCATION_MAX_AGE_MS
) => {
  try {
    const cached = JSON.parse(
      window.localStorage.getItem(LAST_KNOWN_LOCATION_KEY)
    );
    if (
      cached?.latitude == null ||
      cached?.longitude == null ||
      Date.now() - cached.timestamp > maxAgeMs
    ) {
      return null;
    }
    return cached;
  } catch (e) {
    return null;
  }
};

export const distanceInMeters = (lat1, lon1, lat2, lon2) => {
  const toRad = (deg) => (deg * Math.PI) / 180;
  const EARTH_RADIUS_M = 6371000;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return EARTH_RADIUS_M * c;
};

export const validateLocalGeofence = (deviceCoords, locationRecord) => {
  if (!locationRecord) {
    return { valid: false, distance: null, reason: "NO_LOCATION_SELECTED" };
  }
  if (locationRecord.login_from_anywhere === 1) {
    return { valid: true, distance: 0 };
  }
  const lat1 = parseFloat(deviceCoords?.latitude);
  const lon1 = parseFloat(deviceCoords?.longitude);
  const lat2 = parseFloat(locationRecord?.latitude);
  const lon2 = parseFloat(locationRecord?.longitude);
  if ([lat1, lon1, lat2, lon2].some((n) => Number.isNaN(n))) {
    return { valid: true, distance: null, reason: "COORDS_UNAVAILABLE" };
  }
  const radius = Number(locationRecord?.radius) || GEOFENCE_RADIUS_METERS;
  const distance = distanceInMeters(lat1, lon1, lat2, lon2);
  return {
    valid: distance <= radius,
    distance,
    reason: distance <= radius ? undefined : "OUTSIDE_LOCAL_GEOFENCE",
  };
};